// 个人中心
import layout from '@/components/common/layout';
import center from '../views/center/center';
import centerIndex from '../views/center/index';

export default [
    {
        path: '/center',
        component: layout,
        children: [
            {
                path: '',
                meta: {
                    metaInfo: {
                        title: "个人中心",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    /*menu: {
                        parent: '',// 父选项
                        child: '',// 子选项
                    },*/
                },
                component: center,
            },
            {
                path: 'index',
                meta: {
                    metaInfo: {
                        title: "首页 - HelloHRO人力资源管理云平台",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '117',// 父选项
                        child: '',// 子选项
                    },
                },
                component: centerIndex,
            },
        ]
    },
];
